import React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { DATE_FORMATS } from 'constants/util/date-constants';
import { getUserNameByUserId } from 'utils/statement-content-page-utils';

const TooltipContent = ({
  sectionAssignments,
  shouldAssignmentInitialsBeRendered,
  bookmarkId,
  projectUsersList,
  displayElementDetailsOnStatementPage,
  sectionReview,
  SECTION_ANCHOR_BLOCK,
}) => {
  const sectionInReview = () => {
    return (
      Array.isArray(sectionReview.sectionReviews) &&
      sectionReview.sectionReviews
        .filter((review) => review['bookmarkId'] === bookmarkId)
        .map((review) => (
          <div>
            <FormattedMessage
              id={'section-anchor.tooltip-message'}
              values={{
                appUserName: review.appUserName,
                year: moment(review.updatedDate).format(
                  DATE_FORMATS.MONTH_DAY_YEAR,
                ),
                time: moment(review.updatedDate).format(
                  DATE_FORMATS.HOURS_MINUTES,
                ),
              }}
            />
          </div>
        ))
    );
  };

  return (
    <div>
      <>
        <div className={`${SECTION_ANCHOR_BLOCK}__section-reviewers`}>
          {sectionInReview()}
        </div>
        <div className={`${SECTION_ANCHOR_BLOCK}__section-assignments`}>
          {sectionAssignments.sectionAssignments
            .filter(
              (assignments) =>
                assignments.bookmarkId === bookmarkId &&
                shouldAssignmentInitialsBeRendered(
                  assignments.userId,
                  assignments.bookmarkId,
                ),
            )
            .map((assignment) => (
              <div>
                <FormattedMessage
                  id={'section-details.assigned-user.tooltip'}
                  values={{
                    userName: getUserNameByUserId(
                      assignment.userId,
                      projectUsersList,
                    ),
                    date: moment(assignment.date).format(
                      DATE_FORMATS.MONTH_DAY_YEAR,
                    ),
                    time: moment(assignment.date).format(
                      DATE_FORMATS.HOURS_MINUTES,
                    ),
                  }}
                />
              </div>
            ))}
        </div>
      </>
    </div>
  );
};

export default TooltipContent;
